import { MediaMatcher } from '@angular/cdk/layout';
import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, Output, ViewChild, EventEmitter} from '@angular/core';
import { MatPaginator } from '@angular/material';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { DistributionQueueHeaderComponent } from '../distribution-queue/components/distribution-queue-header/distribution-queue-header.component';
import { listRangeDates } from 'src/app/shared/functions/DefaultListRangeDates';
import { IPeriodDate } from '../action-history-queue/interfaces/date-range.interface';
import moment from 'moment-timezone';
import { FormControl } from '@angular/forms';
import { CompanyInterface } from '../core/models/company.model';
import { AuthTokenService } from '../core/services/auth-token/auth-token.service';
import {map, startWith} from 'rxjs/operators';
import { DashboardReportsService } from './dashboard-reports.service';
@Component({
  selector: 'app-dashboard-reports',
  templateUrl: './dashboard-reports.component.html',
  styleUrls: ['./dashboard-reports.component.scss']
})
export class DashboardReportsComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(DistributionQueueHeaderComponent) headerComponent: DistributionQueueHeaderComponent;
  eventSubjectCompany: Subject<any> = new BehaviorSubject<any>([]);
  eventsSubject: Subject<any> = new BehaviorSubject<any>([]);
  periodDateList: IPeriodDate[] = listRangeDates();
  label = 'Hoje';
  periodDate: IPeriodDate = { range: { initialDate: moment().format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD') }, label: this.label };
  date;
  isCustom = false;
  companyList: CompanyInterface[];
  companyListFiltered: Observable<CompanyInterface[]>;
  action = new FormControl([]);
  companyId = "";

  constructor(
    public media: MediaMatcher,
    public changeDetectorRef: ChangeDetectorRef,
    private location: Location,
    private dashboardService: DashboardReportsService,
    private authTokenService : AuthTokenService
  ) { }

  ngOnInit(): void {
    this.emitEventToChild();
    this.getCompanyList();
    
  }

  private _filter(value: string): CompanyInterface[] {

    try {
      const filterValue = value.toLowerCase() || "";
      return this.companyList.filter(option => option.company_name.toLowerCase().includes(filterValue));
    } catch (error) {
      console.log(error);
    }
    return this.companyList;
  }

  selectChange(periodDate: IPeriodDate) {
    this.periodDate = periodDate;
    this.label = periodDate.label;
    this.isCustom = periodDate.label == 'Personalizado';

    if (periodDate.label != 'Personalizado') {
      this.emitEventToChild();
    }
  }

  getCompanyList() {
    this.dashboardService.getCompaniesList().subscribe(resp => {
      this.companyList = [];
      resp.forEach(item => {
        this.companyList.push({
          company_id: item.company_id,
          company_name: item.affiliate_abbreviation,
          legacy_id : item.legacy_id 
        });

        this.configureFilterList();
      });
    });
  }

  configureFilterList() {
    this.companyListFiltered = this.action.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );
  }

  selectAction() {   
    this.actionEmit();
  }

  actionEmit() {
    this.eventSubjectCompany.next(this.action.value.legacy_id);
    this.action.setValue(this.action.value.company_name);
  }

  dateChange(date: string[]): void {
    let range = {
      initialDate: '',
      endDate: ''
    };
    
    if (date.length) {
      range = {
        initialDate: moment(date.shift()).format('YYYY-MM-DD'),
        endDate: moment(date.shift()).format('YYYY-MM-DD')
      };
    }

    this.label = 'Personalizado';
    this.periodDate = { label: this.label, range };
    this.emitEventToChild();
  }

  emitEventToChild() {
    this.eventsSubject.next(this.periodDate);
  }

  back() {
    this.location.back();
  }

  isUserAdministrator(): boolean {
    return this.authTokenService.isAdministrator();
  }
}
